import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import Religion from './religion';
import ReligionDetail from './religion-detail';
import ReligionUpdate from './religion-update';
import ReligionDeleteDialog from './religion-delete-dialog';

const ReligionRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<Religion />} />
    <Route path="new" element={<ReligionUpdate />} />
    <Route path=":id">
      <Route index element={<ReligionDetail />} />
      <Route path="edit" element={<ReligionUpdate />} />
      <Route path="delete" element={<ReligionDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default ReligionRoutes;
